import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Newspaper, CalendarDays, Search, Mail } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#1B4F72] rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>E</span>
              </div>
              <div>
                <h2 className="text-xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Expo Haber
                </h2>
                <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-stone-500 block -mt-0.5">
                  Türkiye
                </span>
              </div>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed max-w-sm">
              Fuar ve etkinlik sektörünün dijital gazetesi. Güncel haberler, sektör
              analizleri, etkinlik takvimi ve yapay zeka destekli bilgi bankası
              ile sektörün nabzını tutuyoruz.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h3 className="font-mono text-[10px] uppercase tracking-widest text-stone-500 mb-4">
              Sayfalar
            </h3>
            <nav className="space-y-3">
              <Link to="/" className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors">
                <Newspaper className="w-3.5 h-3.5" />
                Ana Sayfa
              </Link>
              <Link to="/takvim" className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors">
                <CalendarDays className="w-3.5 h-3.5" />
                Fuar Takvimi
              </Link>
              <Link to="/arama" className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors">
                <Search className="w-3.5 h-3.5" />
                Haber Arama
              </Link>
            </nav>
          </div>

          {/* Categories */}
          <div className="md:col-span-4">
            <h3 className="font-mono text-[10px] uppercase tracking-widest text-stone-500 mb-4">
              Kategoriler
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {[
                "Stand Tasarımı",
                "Lojistik",
                "Sektör Trendleri",
                "Teknoloji",
                "Sürdürülebilirlik",
                "Pazar Analizi",
              ].map((cat) => (
                <span
                  key={cat}
                  className="text-sm text-stone-400"
                >
                  {cat}
                </span>
              ))}
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-stone-800" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-widest text-stone-500">
            &copy; {currentYear} Expo Haber. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-2">
            <Mail className="w-3 h-3 text-stone-500" />
            <span className="font-mono text-[10px] text-stone-500">
              info@expohaber.com
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
